import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as parse from 'date-fns/parse';
import * as distanceInWordsToNow from 'date-fns/distance_in_words_to_now';

// Services
import {
  IGetPersonResponse,
  getPerson,
  editPerson,
  deletePerson
} from '../../services/person';

// Types
export type IPerson = IGetPersonResponse;
import { IFormValues } from './UserDialogDetailsEdit';

// Components
import Dialog from '../../components/Dialog';
import Grid from '../../components/Grid';
import Paper from '../../components/Paper';
import { CircularProgress } from '../../components/Progress';
import Tabs, { Tab } from '../../components/Tabs';
import Typography from '../../components/Typography';

import UserModalDetailsTab from './UserDialogDetails';
import UserDialogTagsTaxonomy from './UserDialogTagsTaxonomy';

// Style
import './UserDialog.css';

// Component
interface IProps {
  networkId: string;
  state: { open: boolean; userId: string | null };
  onClose?: () => void;
  onExited?: () => void;
  userRole: 'USER' | 'ADMIN';
}

class UserDialog extends React.Component<IProps, {}> {
  @observable person: IPerson | null = null;

  @observable detailsMode: 'edit' | 'view' = 'view';

  @observable tabIndex = 0;

  async getUser() {
    const networkId = this.props.networkId;
    const userId = this.props.state.userId;
    if (userId) {
      this.person = await getPerson({
        params: { networkId },
        query: { userId }
      });
    }
  }

  handleDetailsEditSubmit = async (values: IFormValues) => {
    try {
      await editPerson({
        params: { networkId: this.props.networkId },
        query: { userId: this.person!.userId },
        body: values
      });
    } finally {
      this.detailsMode = 'view';
    }
  };

  handleDetailsEditClick = () => {
    this.detailsMode = 'edit';
  };

  handleDetailsEditDelete = async () => {
    try {
      await deletePerson({
        params: { networkId: this.props.networkId },
        query: { userId: this.person!.userId }
      });
    } finally {
      this.detailsMode = 'view';
    }
  };

  handleDialogEnter = async () => {
    this.getUser();
  };

  handleDialogExited = () => {
    this.person = null;
    this.detailsMode = 'view';
  };

  handleTabChange = (e: React.MouseEvent<HTMLButtonElement>, index: number) => {
    this.tabIndex = index;
  };

  render() {
    return (
      <Dialog
        open={this.props.state.open}
        onClose={this.props.onClose}
        onEnter={this.handleDialogEnter}
        onExited={this.handleDialogExited}
        classes={{ paper: 'AppNetworkPeople_UserDialog_Paper' }}
      >
        {this.person === null ? (
          <Grid
            container={true}
            direction="column"
            alignItems="center"
            justify="center"
            spacing={0}
            style={{ height: 700 }}
          >
            <CircularProgress />
          </Grid>
        ) : (
          <div>
            <Paper
              style={{
                background: 'linear-gradient(45deg, #FF4A5D 0%, #FF924A 100%)',
                color: '#fff',
                position: 'relative',
                zIndex: 10
              }}
              square={true}
            >
              <div
                style={{
                  paddingTop: 48,
                  paddingBottom: 16,
                  textAlign: 'center'
                }}
              >
                <img
                  height={158}
                  width={158}
                  style={{
                    borderRadius: '50%',
                    boxShadow:
                      '0px 2px 4px -1px rgba(0, 0, 0, 0.2),' +
                      ' 0px 4px 5px 0px rgba(0, 0, 0, 0.14),' +
                      ' 0px 1px 10px 0px rgba(0, 0, 0, 0.12)'
                  }}
                  src={this.person.photoUrl || '//i.imgur.com/wkbr0Z0.png'}
                />
                <br />
                <br />
                <Typography type="headline" color="inherit">
                  {`${this.person.firstName} ${this.person.lastName}`}
                </Typography>
                <Typography
                  type="subheading"
                  color="inherit"
                  style={{ opacity: 0.6 }}
                >
                  {`Active ${distanceInWordsToNow(parse(`${this.person.lastLogin}Z`))} ago`}
                </Typography>
              </div>
              <Tabs
                value={this.tabIndex}
                onChange={this.handleTabChange}
                centered={true}
              >
                <Tab label="Details" />
                <Tab label="Tags" />
              </Tabs>
            </Paper>
            <div
              style={{ height: 400, overflowY: 'auto', background: '#f4f5fa' }}
            >
              {this.tabIndex === 0 ? (
                <UserModalDetailsTab
                  mode={this.detailsMode}
                  person={this.person}
                  onEditClick={this.handleDetailsEditClick}
                  onSubmit={this.handleDetailsEditSubmit}
                  onDelete={this.handleDetailsEditDelete}
                  userRole={this.props.userRole}
                />
              ) : null}
              {this.tabIndex === 1 ? (
                <UserDialogTagsTaxonomy
                  userId={this.person!.userId}
                  networkId={this.props.networkId}
                  userRole={this.props.userRole}
                />
              ) : null}
            </div>
          </div>
        )}
      </Dialog>
    );
  }
}

export default observer(UserDialog);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/UserDialog.tsx